import { render, staticRenderFns } from "./TableDelegations.vue?vue&type=template&id=3c4182d4&"
import script from "./TableDelegations.vue?vue&type=script&lang=js&"
export * from "./TableDelegations.vue?vue&type=script&lang=js&"
import style0 from "./TableDelegations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports